import { FormattedMessage } from 'components/shared/Intl';
import {
  ConnectedTradeWayLiteral,
  FlowWayLiteral,
  PriceNext,
  QuoteStatus,
  SolveResult,
  Spinner,
} from 'components/shared/PriceNext';
import type { PropsWithChildren } from 'react';

import { SolveModeLabel } from '../SolveMode';
import { connectTradePending, TradePendingState } from '../trade.pending/trade.pending.connect';

export function Component({
  tabId,
  workspaceType,
  solvingMode,
  solveResult,
  solveResultFormat,
  isMultipleSolvingMode,
  priceInPercent = 0,
  priceInCurrency = 0,
  currency = '',
  flowWay,
}: PropsWithChildren<TradePendingState>) {
  const hasSolveResult = solveResult !== undefined;

  return (
    <PriceNext
      className="sg-price bg-warning text-warning bg-opacity-10"
      tradeWay={<ConnectedTradeWayLiteral tabId={tabId} workspaceType={workspaceType} />}
      solveMode={
        <SolveModeLabel
          workspaceType={workspaceType}
          solvingMode={solvingMode}
          isMultipleSolvingMode={isMultipleSolvingMode}
        />
      }
      shareButton={
        <span className="badge badge-outline-warning badge-xl m-2 rounded-pill fw-bold">
          <FormattedMessage id="pleaseWait" />
        </span>
      }
      solveResult={<SolveResult price={solveResult} priceFormat={solveResultFormat} />}
      flowWay={
        hasSolveResult && (
          <FlowWayLiteral
            flowWay={flowWay}
            priceInPercent={priceInPercent}
            priceInCurrency={priceInCurrency}
            currency={currency}
          />
        )
      }
      quoteStatus={
        <QuoteStatus
          className="alert alert-warning"
          icon={Spinner}
          description="sidePanel.quoteStatus.bookingInProgress"
        />
      }
    />
  );
}

export const BookingPendingComponent = connectTradePending(Component);

Component.displayName = 'BookingPendingComponent';
